import { useCallback, useState } from 'react';
import { searchSavedTicket } from './api';
import { fromJS, List } from 'immutable';
import useDebounce from '@/_hooks/useDebounce';
import { fireGAEvent } from '@/analytics';

export function useSavedTicketsSearch(initialValue = '') {
    const [query, setQuery] = useState(initialValue);
    const [searchResult, setSearchResult] = useState(null);

    const handleFetch = useDebounce(
        newQuery => {
            if (newQuery) {
                searchSavedTicket(newQuery)
                    .then(ticket => {
                        setSearchResult(fromJS([ticket]));
                    })
                    .catch(() => setSearchResult(List()))
                    .finally(() => {
                        fireGAEvent('Tikety ulozene', 'Vyhladavanie v ulozenych tiketoch', 'Filter');
                    });
            } else {
                setSearchResult(List());
            }
        },
        500,
        []
    );

    const onQueryChange = useCallback(
        function onQueryChange(value) {
            const newQuery = value.replace(/\s/g, '');
            setQuery(newQuery);
            setSearchResult(null);
            handleFetch(newQuery);
        },
        [handleFetch]
    );

    return {
        query,
        searchResult,
        onQueryChange
    };
}
